var _path, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShapeTitleUnderLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 258,
    height: 18,
    viewBox: "0 0 258 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M254.5 7C256.433 7 258 5.433 258 3.5C258 1.567 256.433 0 254.5 0C252.737 0 251.278 1.30385 251.035 3H240.5H240.321L240.182 3.11403L223.321 17H0V18H223.5H223.679L223.818 17.886L240.679 4H251.035C251.278 5.69615 252.737 7 254.5 7Z",
    fill: "url(#paint0_linear_715_98)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_715_98",
    x1: 255.5,
    y1: -0.999958,
    x2: 0.00000577591,
    y2: 8.00004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0044EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapeTitleUnderLine);
export default __webpack_public_path__ + "static/media/shape_title_under_line.3ca1c5355632ad010beb6287c0397cd6.svg";
export { ForwardRef as ReactComponent };